import mixpanel from "mixpanel-browser";

const useMixpanelTracker = () => {
  mixpanel.init(
    window.location.host === "offer.sunrun.com"
      ? "73d911fcd247037193404ee54ca34050"
      : "86a764ad97c52ad199cc8ed33854fe82",
    { persistence: "localStorage" }
  );
};

const Mixpanel = {
  identify: (id: any) => {
    mixpanel.identify(id);
  },
  alias: (id: any) => {
    mixpanel.alias(id);
  },
  track: (name: string, props: any) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      mixpanel.people.set(props);
    },
  },
};

export { useMixpanelTracker, Mixpanel };
